





























































import { Vue, Component, Prop } from "../vue-ext";
import { HousingCompany, Account, OwnInfo } from "../models";

@Component
export default class OwnInfoView extends Vue {
    private ownInfo: OwnInfo | null = null;
    private account: Account | null = null; 
    private housingCompany: HousingCompany | null = null;
    private additionalInfo: string = "";
    private noticeSentSuccessfully: boolean = false;

    private async created() {
        this.root.setTitle(this.$t("menu.ownInfo") as string);
        this.root.setIconClass("icon-user1");

        this.account = this.root.getCurrentAccount() as Account;
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;
        this.ownInfo = this.root.ownInfo;
    }

    private async save() {
        if (this.ownInfo) {
            const res = await this.root.service.user.UpdateOwnInfo(this.ownInfo, this.additionalInfo);

            if (!res.isError) {
                this.noticeSentSuccessfully = true;
            }
        }
    }
}
